import { render, staticRenderFns } from "./_activeRecord.vue?vue&type=template&id=130f515c&scoped=true"
import script from "./_activeRecord.vue?vue&type=script&lang=js"
export * from "./_activeRecord.vue?vue&type=script&lang=js"
import style0 from "./_activeRecord.vue?vue&type=style&index=0&id=130f515c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130f515c",
  null
  
)

export default component.exports